import { useRef } from "react"
import { useNavigate } from "react-router-dom"

import { Button, ButtonSize } from "../../../../components/Button"
import { useTextStorage, useImagePreload } from "../../../../hooks"
import "./FamilySection.scss"

import {
  services3Bg2,
  services3Hq,
  services3Lq,
  testimonialDecor as services1Decor,
} from "../../../../assets/images"

export const FamilySection: React.FC = () => {
  const { ts } = useTextStorage()
  const navigate = useNavigate()

  const hqRef = useRef<HTMLImageElement>(null)
  useImagePreload(services3Hq, hqRef)

  const handleConnectButtonClick = () => {
    navigate("/#connect")
  }

  const handleGalleryButtonClick = () => {
    navigate("/gallery")
  }

  return (
    <div className="family-section">
      <h2>{ts.pages.services.sections[2].title}</h2>
      <div className="family-section--image-container">
        <img
          src={services3Bg2}
          alt="family-section-bg"
          className="family-section--bg"
        />
        <img
          src={services3Lq}
          alt="family-section-pic-lq"
          className="family-section--lq"
        />
        <img
          ref={hqRef}
          src={services3Hq}
          alt="family-section-pic-hq"
          className="family-section--hq"
        />
        <img
          src={services1Decor}
          alt="family-section-decor"
          className="family-section--decor"
        />
      </div>
      <div className="family-section--content">
        <h2>{ts.pages.services.sections[2].title}</h2>
        {ts.pages.services.sections[2].paragraphs.map((paragraph, i) => (
          <p key={`family-section--paragraph-${i}`}>{paragraph}</p>
        ))}
        <div className="family-section--content--buttons-container">
          <Button
            text={ts.pages.services.buttonTextConnect}
            size={ButtonSize.MD}
            onClick={handleConnectButtonClick}
          />
          <Button
            text={ts.pages.services.buttonTextGallery}
            size={ButtonSize.MD}
            onClick={handleGalleryButtonClick}
          />
        </div>
      </div>
    </div>
  )
}
